<template>
  <div>
    <router-view></router-view>
    <div class="bottom-nav">
      <div
        class="item"
        :class="{ active: homeStyle }"
        @click="goPage('/index')"
      >
        <div class="icon home"></div>
        <div class="text">首页</div>
      </div>
      <div
        class="item"
        :class="{ active: goodsStyle }"
        @click="goPage('/goods')"
      >
        <div class="icon shop"></div>
        <div class="text">市场</div>
      </div>
      <div class="item" :class="{ active: myStyle }" @click="goPage('/user')">
        <div class="icon user"></div>
        <div class="text">我的</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      homeStyle: true,
      goodsStyle: false,
      myStyle: false,
    };
  },
  methods: {
    goPage(url) {
      this.$router.replace(url);
    },
    changeStyleNav(name) {
      switch (name) {
        case "index":
          this.homeStyle = true;
          this.goodsStyle = false;
          this.myStyle = false;
          break;
        case "goods":
          this.homeStyle = false;
          this.goodsStyle = true;
          this.myStyle = false;
          break;
        case "user":
          this.homeStyle = false;
          this.goodsStyle = false;
          this.myStyle = true;
          break;
        default:
          this.homeStyle = true;
          this.goodsStyle = false;
          this.myStyle = false;
          break;
      }
    },
  },
  created() {
    document.title = this.$route.meta.title;
    this.changeStyleNav(this.$route.name);
  },
  beforeRouteUpdate(to, from, next) {
    // console.log(to);
    document.title = to.meta.title;
    this.changeStyleNav(to.name);
    next();
  },
  activated() {
    document.title = this.$route.meta.title;
    this.changeStyleNav(this.$route.name);
  },
};
</script>

<style scoped lang="scss">
.bottom-nav {
  width: 100%;
  height: 1.2rem;
  background: url("../../../assets/images/home/main/nav-bg.png") no-repeat left
    bottom;
  background-size: 100% auto;
  position: fixed;
  z-index: 10;
  left: 0px;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0.6rem;
  box-sizing: border-box;

  .item {
    width: 1rem;
    text-align: center;
    font-size: 0;
    .icon {
      position: relative;
      width: 0.6rem;
      height: 0.6rem;
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: center;
      margin: 0 auto;
      transition: 0.3s;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-size: auto 0.38rem;
        background-repeat: no-repeat;
        background-position: center;
        transition: 0.3s;
      }
      &.home {
        &::after {
          background-image: url("../../../assets/images/home/main/nav1.png");
        }
      }
      &.shop {
        &::after {
          background-image: url("../../../assets/images/home/main/nav2.png");
        }
      }
      &.user {
        &::after {
          background-image: url("../../../assets/images/home/main/nav3.png");
        }
      }
    }
    .text {
      font-size: 0.24rem;
      color: #595b5f;
      margin-top: 0.05rem;
    }

    &.active {
      .icon {
        background-image: url("../../../assets/images/home/main/nav-btn-bg.png");

        &.home {
          &::after {
            background-image: url("../../../assets/images/home/main/nav1-on.png");
          }
        }
        &.shop {
          &::after {
            background-image: url("../../../assets/images/home/main/nav2-on.png");
          }
        }
        &.user {
          &::after {
            background-image: url("../../../assets/images/home/main/nav3-on.png");
          }
        }
      }
      .text {
        color: #b1aa98;
        text-shadow: -0.5px 0px 0.5px #1d1916, 0.5px 0px 0.5px #1d1916,
          0px -0.5px 0.5px #1d1916, 0px 0.5px 0.5px #1d1916;
      }
    }
  }
  ul {
    width: 1rem;

    li {
      &:nth-child(1) {
        width: 0.38rem;
        height: 0.38rem;
        margin: 0 auto;
      }

      &:nth-child(2) {
        font-size: 0.24rem;
        text-align: center;
      }
    }
    &.active {
      li:nth-child(2) {
        color: #eb1625;
      }
    }
  }
}
</style>